import { useRef, useState } from "react";

import { Text } from "./Text";
import type { TextProps } from "./Text";
import { Tooltip, TooltipContent, TooltipTrigger } from "./Tooltip";

type TruncatedTextProps = Omit<TextProps, "truncate">;

const TruncatedText = ({ children, ...props }: TruncatedTextProps) => {
  const ref = useRef<HTMLSpanElement>(null);
  const [open, setOpen] = useState(false);

  const handleOpenChange = (next: boolean) => {
    const element = ref.current;
    setOpen(next && element !== null && element.scrollWidth > element.clientWidth);
  };

  return (
    <Tooltip open={open} onOpenChange={handleOpenChange}>
      <TooltipTrigger asChild>
        <Text ref={ref} truncate {...props}>
          {children}
        </Text>
      </TooltipTrigger>
      <TooltipContent>{children}</TooltipContent>
    </Tooltip>
  );
};

export { TruncatedText };
export type { TruncatedTextProps };
